  //  SLICK SLIDER
  (function (a) {
    "use strict";
    typeof define == "function" && define.amd
      ? define(["jquery"], a)
      : typeof exports < "u"
      ? (module.exports = a(require("jquery")))
      : a(jQuery);
  })(function (a) {
    "use strict";
    var b = window.Slick || {};
    (b = (function () {
      function c(c2, d) {
        var f,
          e = this;
        (e.defaults = {
          accessibility: !0,
          adaptiveHeight: !1,
          appendArrows: a(c2),
          appendDots: a(c2),
          arrows: !0,
          asNavFor: null,
          prevArrow:
            '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
          nextArrow:
            '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
          autoplay: !1,
          autoplaySpeed: 3e3,
          centerMode: !1,
          centerPadding: "50px",
          cssEase: "ease",
          customPaging: function (b3, c3) {
            return a(
              '<button type="button" data-role="none" role="button" tabindex="0" />'
            ).text(c3 + 1);
          },
          dots: !1,
          dotsClass: "slick-dots",
          draggable: !0,
          easing: "linear",
          edgeFriction: 0.35,
          fade: !1,
          focusOnSelect: !1,
          infinite: !0,
          initialSlide: 0,
          lazyLoad: "ondemand",
          mobileFirst: !1,
          pauseOnHover: !0,
          pauseOnFocus: !0,
          pauseOnDotsHover: !1,
          respondTo: "window",
          responsive: null,
          rows: 1,
          rtl: !1,
          slide: "",
          slidesPerRow: 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 500,
          swipe: !0,
          swipeToSlide: !1,
          touchMove: !0,
          touchThreshold: 5,
          useCSS: !0,
          useTransform: !0,
          variableWidth: !1,
          vertical: !1,
          verticalSwiping: !1,
          waitForAnimate: !0,
          zIndex: 1e3,
        }),
          (e.initials = {
            animating: !1,
            dragging: !1,
            autoPlayTimer: null,
            currentDirection: 0,
            currentLeft: null,
            currentSlide: 0,
            direction: 1,
            $dots: null,
            listWidth: null,
            listHeight: null,
            loadIndex: 0,
            $nextArrow: null,
            $prevArrow: null,
            slideCount: null,
            slideWidth: null,
            $slideTrack: null,
            $slides: null,
            sliding: !1,
            slideOffset: 0,
            swipeLeft: null,
            $list: null,
            touchObject: {},
            transformsEnabled: !1,
            unslicked: !1,
          }),
          a.extend(e, e.initials),
          (e.activeBreakpoint = null),
          (e.animType = null),
          (e.animProp = null),
          (e.breakpoints = []),
          (e.breakpointSettings = []),
          (e.cssTransitions = !1),
          (e.focussed = !1),
          (e.interrupted = !1),
          (e.hidden = "hidden"),
          (e.paused = !0),
          (e.positionProp = null),
          (e.respondTo = null),
          (e.rowCount = 1),
          (e.shouldClick = !0),
          (e.$slider = a(c2)),
          (e.$slidesCache = null),
          (e.transformType = null),
          (e.transitionType = null),
          (e.visibilityChange = "visibilitychange"),
          (e.windowWidth = 0),
          (e.windowTimer = null),
          (f = a(c2).data("slick") || {}),
          (e.options = a.extend({}, e.defaults, d, f)),
          (e.currentSlide = e.options.initialSlide),
          (e.originalSettings = e.options),
          typeof document.mozHidden < "u"
            ? ((e.hidden = "mozHidden"),
              (e.visibilityChange = "mozvisibilitychange"))
            : typeof document.webkitHidden < "u" &&
              ((e.hidden = "webkitHidden"),
              (e.visibilityChange = "webkitvisibilitychange")),
          (e.autoPlay = a.proxy(e.autoPlay, e)),
          (e.autoPlayClear = a.proxy(e.autoPlayClear, e)),
          (e.autoPlayIterator = a.proxy(e.autoPlayIterator, e)),
          (e.changeSlide = a.proxy(e.changeSlide, e)),
          (e.clickHandler = a.proxy(e.clickHandler, e)),
          (e.selectHandler = a.proxy(e.selectHandler, e)),
          (e.setPosition = a.proxy(e.setPosition, e)),
          (e.swipeHandler = a.proxy(e.swipeHandler, e)),
          (e.dragHandler = a.proxy(e.dragHandler, e)),
          (e.keyHandler = a.proxy(e.keyHandler, e)),
          (e.instanceUid = b2++),
          (e.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
          e.registerBreakpoints(),
          e.init(!0);
      }
      var b2 = 0;
      return c;
    })()),
      (b.prototype.activateADA = function () {
        var a2 = this;
        a2.$slideTrack
          .find(".slick-active")
          .attr({ "aria-hidden": "false" })
          .find("a, input, button, select")
          .attr({ tabindex: "0" });
      }),
      (b.prototype.addSlide = b.prototype.slickAdd =
        function (b2, c, d) {
          var e = this;
          if (typeof c == "boolean") (d = c), (c = null);
          else if (0 > c || c >= e.slideCount) return !1;
          e.unload(),
            typeof c == "number"
              ? c === 0 && e.$slides.length === 0
                ? a(b2).appendTo(e.$slideTrack)
                : d
                ? a(b2).insertBefore(e.$slides.eq(c))
                : a(b2).insertAfter(e.$slides.eq(c))
              : d === !0
              ? a(b2).prependTo(e.$slideTrack)
              : a(b2).appendTo(e.$slideTrack),
            (e.$slides = e.$slideTrack.children(this.options.slide)),
            e.$slideTrack.children(this.options.slide).detach(),
            e.$slideTrack.append(e.$slides),
            e.$slides.each(function (b3, c2) {
              a(c2).attr("data-slick-index", b3);
            }),
            (e.$slidesCache = e.$slides),
            e.reinit();
        }),
      (b.prototype.animateHeight = function () {
        var a2 = this;
        if (
          a2.options.slidesToShow === 1 &&
          a2.options.adaptiveHeight === !0 &&
          a2.options.vertical === !1
        ) {
          var b2 = a2.$slides.eq(a2.currentSlide).outerHeight(!0);
          a2.$list.animate({ height: b2 }, a2.options.speed);
        }
      }),
      (b.prototype.animateSlide = function (b2, c) {
        var d = {},
          e = this;
        e.animateHeight(),
          e.options.rtl === !0 && e.options.vertical === !1 && (b2 = -b2),
          e.transformsEnabled === !1
            ? e.options.vertical === !1
              ? e.$slideTrack.animate(
                  { left: b2 },
                  e.options.speed,
                  e.options.easing,
                  c
                )
              : e.$slideTrack.animate(
                  { top: b2 },
                  e.options.speed,
                  e.options.easing,
                  c
                )
            : e.cssTransitions === !1
            ? (e.options.rtl === !0 && (e.currentLeft = -e.currentLeft),
              a({ animStart: e.currentLeft }).animate(
                { animStart: b2 },
                {
                  duration: e.options.speed,
                  easing: e.options.easing,
                  step: function (a2) {
                    (a2 = Math.ceil(a2)),
                      e.options.vertical === !1
                        ? ((d[e.animType] = "translate(" + a2 + "px, 0px)"),
                          e.$slideTrack.css(d))
                        : ((d[e.animType] = "translate(0px," + a2 + "px)"),
                          e.$slideTrack.css(d));
                  },
                  complete: function () {
                    c && c.call();
                  },
                }
              ))
            : (e.applyTransition(),
              (b2 = Math.ceil(b2)),
              e.options.vertical === !1
                ? (d[e.animType] = "translate3d(" + b2 + "px, 0px, 0px)")
                : (d[e.animType] = "translate3d(0px," + b2 + "px, 0px)"),
              e.$slideTrack.css(d),
              c &&
                setTimeout(function () {
                  e.disableTransition(), c.call();
                }, e.options.speed));
      }),
      (b.prototype.getNavTarget = function () {
        var b2 = this,
          c = b2.options.asNavFor;
        return c && c !== null && (c = a(c).not(b2.$slider)), c;
      }),
      (b.prototype.asNavFor = function (b2) {
        var c = this,
          d = c.getNavTarget();
        d !== null &&
          typeof d == "object" &&
          d.each(function () {
            var c2 = a(this).slick("getSlick");
            c2.unslicked || c2.slideHandler(b2, !0);
          });
      }),
      (b.prototype.applyTransition = function (a2) {
        var b2 = this,
          c = {};
        b2.options.fade === !1
          ? (c[b2.transitionType] =
              b2.transformType +
              " " +
              b2.options.speed +
              "ms " +
              b2.options.cssEase)
          : (c[b2.transitionType] =
              "opacity " + b2.options.speed + "ms " + b2.options.cssEase),
          b2.options.fade === !1
            ? b2.$slideTrack.css(c)
            : b2.$slides.eq(a2).css(c);
      }),
      (b.prototype.autoPlay = function () {
        var a2 = this;
        a2.autoPlayClear(),
          a2.slideCount > a2.options.slidesToShow &&
            (a2.autoPlayTimer = setInterval(
              a2.autoPlayIterator,
              a2.options.autoplaySpeed
            ));
      }),
      (b.prototype.autoPlayClear = function () {
        var a2 = this;
        a2.autoPlayTimer && clearInterval(a2.autoPlayTimer);
      }),
      (b.prototype.autoPlayIterator = function () {
        var a2 = this,
          b2 = a2.currentSlide + a2.options.slidesToScroll;
        a2.paused ||
          a2.interrupted ||
          a2.focussed ||
          (a2.options.infinite === !1 &&
            (a2.direction === 1 && a2.currentSlide + 1 === a2.slideCount - 1
              ? (a2.direction = 0)
              : a2.direction === 0 &&
                ((b2 = a2.currentSlide - a2.options.slidesToScroll),
                a2.currentSlide - 1 === 0 && (a2.direction = 1))),
          a2.slideHandler(b2));
      }),
      (b.prototype.buildArrows = function () {
        var b2 = this;
        b2.options.arrows === !0 &&
          ((b2.$prevArrow = a(b2.options.prevArrow).addClass("slick-arrow")),
          (b2.$nextArrow = a(b2.options.nextArrow).addClass("slick-arrow")),
          b2.slideCount > b2.options.slidesToShow
            ? (b2.$prevArrow
                .removeClass("slick-hidden")
                .removeAttr("aria-hidden tabindex"),
              b2.$nextArrow
                .removeClass("slick-hidden")
                .removeAttr("aria-hidden tabindex"),
              b2.htmlExpr.test(b2.options.prevArrow) &&
                b2.$prevArrow.prependTo(b2.options.appendArrows),
              b2.htmlExpr.test(b2.options.nextArrow) &&
                b2.$nextArrow.appendTo(b2.options.appendArrows),
              b2.options.infinite !== !0 &&
                b2.$prevArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"))
            : b2.$prevArrow
                .add(b2.$nextArrow)
                .addClass("slick-hidden")
                .attr({ "aria-disabled": "true", tabindex: "-1" }));
      }),
      (b.prototype.buildDots = function () {
        var c,
          d,
          b2 = this;
        if (b2.options.dots === !0 && b2.slideCount > b2.options.slidesToShow) {
          for (
            b2.$slider.addClass("slick-dotted"),
              d = a("<ul />").addClass(b2.options.dotsClass),
              c = 0;
            c <= b2.getDotCount();
            c += 1
          )
            d.append(
              a("<li />").append(b2.options.customPaging.call(this, b2, c))
            );
          (b2.$dots = d.appendTo(b2.options.appendDots)),
            b2.$dots
              .find("li")
              .first()
              .addClass("slick-active")
              .attr("aria-hidden", "false");
        }
      }),
      (b.prototype.buildOut = function () {
        var b2 = this;
        (b2.$slides = b2.$slider
          .children(b2.options.slide + ":not(.slick-cloned)")
          .addClass("slick-slide")),
          (b2.slideCount = b2.$slides.length),
          b2.$slides.each(function (b3, c) {
            a(c)
              .attr("data-slick-index", b3)
              .data("originalStyling", a(c).attr("style") || "");
          }),
          b2.$slider.addClass("slick-slider"),
          (b2.$slideTrack =
            b2.slideCount === 0
              ? a(
                  '<div class="slick-track" aria-label="slide image"/>'
                ).appendTo(b2.$slider)
              : b2.$slides
                  .wrapAll('<div class="slide image" aria-label="slide"/>')
                  .parent()),
          (b2.$list = b2.$slideTrack
            .wrap('<div aria-live="polite" class="slick-list"/>')
            .parent()),
          b2.$slideTrack.css("opacity", 0),
          (b2.options.centerMode === !0 || b2.options.swipeToSlide === !0) &&
            (b2.options.slidesToScroll = 1),
          a("img[data-lazy]", b2.$slider)
            .not("[src]")
            .addClass("slick-loading"),
          b2.setupInfinite(),
          b2.buildArrows(),
          b2.buildDots(),
          b2.updateDots(),
          b2.setSlideClasses(
            typeof b2.currentSlide == "number" ? b2.currentSlide : 0
          ),
          b2.options.draggable === !0 && b2.$list.addClass("draggable");
      }),
      (b.prototype.buildRows = function () {
        var b2,
          c,
          d,
          e,
          f,
          g,
          h,
          a2 = this;
        if (
          ((e = document.createDocumentFragment()),
          (g = a2.$slider.children()),
          a2.options.rows > 1)
        ) {
          for (
            h = a2.options.slidesPerRow * a2.options.rows,
              f = Math.ceil(g.length / h),
              b2 = 0;
            f > b2;
            b2++
          ) {
            var i = document.createElement("div");
            for (c = 0; c < a2.options.rows; c++) {
              var j = document.createElement("div");
              for (d = 0; d < a2.options.slidesPerRow; d++) {
                var k = b2 * h + (c * a2.options.slidesPerRow + d);
                g.get(k) && j.appendChild(g.get(k));
              }
              i.appendChild(j);
            }
            e.appendChild(i);
          }
          a2.$slider.empty().append(e),
            a2.$slider
              .children()
              .children()
              .children()
              .css({
                width: 100 / a2.options.slidesPerRow + "%",
                display: "inline-block",
              });
        }
      }),
      (b.prototype.checkResponsive = function (b2, c) {
        var e,
          f,
          g,
          d = this,
          h = !1,
          i = d.$slider.width(),
          j = window.innerWidth || a(window).width();
        if (
          (d.respondTo === "window"
            ? (g = j)
            : d.respondTo === "slider"
            ? (g = i)
            : d.respondTo === "min" && (g = Math.min(j, i)),
          d.options.responsive &&
            d.options.responsive.length &&
            d.options.responsive !== null)
        ) {
          f = null;
          for (e in d.breakpoints)
            d.breakpoints.hasOwnProperty(e) &&
              (d.originalSettings.mobileFirst === !1
                ? g < d.breakpoints[e] && (f = d.breakpoints[e])
                : g > d.breakpoints[e] && (f = d.breakpoints[e]));
          f !== null
            ? d.activeBreakpoint !== null
              ? (f !== d.activeBreakpoint || c) &&
                ((d.activeBreakpoint = f),
                d.breakpointSettings[f] === "unslick"
                  ? d.unslick(f)
                  : ((d.options = a.extend(
                      {},
                      d.originalSettings,
                      d.breakpointSettings[f]
                    )),
                    b2 === !0 && (d.currentSlide = d.options.initialSlide),
                    d.refresh(b2)),
                (h = f))
              : ((d.activeBreakpoint = f),
                d.breakpointSettings[f] === "unslick"
                  ? d.unslick(f)
                  : ((d.options = a.extend(
                      {},
                      d.originalSettings,
                      d.breakpointSettings[f]
                    )),
                    b2 === !0 && (d.currentSlide = d.options.initialSlide),
                    d.refresh(b2)),
                (h = f))
            : d.activeBreakpoint !== null &&
              ((d.activeBreakpoint = null),
              (d.options = d.originalSettings),
              b2 === !0 && (d.currentSlide = d.options.initialSlide),
              d.refresh(b2),
              (h = f)),
            b2 || h === !1 || d.$slider.trigger("breakpoint", [d, h]);
        }
      }),
      (b.prototype.changeSlide = function (b2, c) {
        var f,
          g,
          h,
          d = this,
          e = a(b2.currentTarget);
        switch (
          (e.is("a") && b2.preventDefault(),
          e.is("li") || (e = e.closest("li")),
          (h = d.slideCount % d.options.slidesToScroll !== 0),
          (f = h
            ? 0
            : (d.slideCount - d.currentSlide) % d.options.slidesToScroll),
          b2.data.message)
        ) {
          case "previous":
            (g =
              f === 0 ? d.options.slidesToScroll : d.options.slidesToShow - f),
              d.slideCount > d.options.slidesToShow &&
                d.slideHandler(d.currentSlide - g, !1, c);
            break;
          case "next":
            (g = f === 0 ? d.options.slidesToScroll : f),
              d.slideCount > d.options.slidesToShow &&
                d.slideHandler(d.currentSlide + g, !1, c);
            break;
          case "index":
            var i =
              b2.data.index === 0
                ? 0
                : b2.data.index || e.index() * d.options.slidesToScroll;
            d.slideHandler(d.checkNavigable(i), !1, c),
              e.children().trigger("focus");
            break;
          default:
            return;
        }
      }),
      (b.prototype.checkNavigable = function (a2) {
        var c,
          d,
          b2 = this;
        if (((c = b2.getNavigableIndexes()), (d = 0), a2 > c[c.length - 1]))
          a2 = c[c.length - 1];
        else
          for (var e in c) {
            if (a2 < c[e]) {
              a2 = d;
              break;
            }
            d = c[e];
          }
        return a2;
      }),
      (b.prototype.cleanUpEvents = function () {
        var b2 = this;
        b2.options.dots &&
          b2.$dots !== null &&
          a("li", b2.$dots)
            .off("click.slick", b2.changeSlide)
            .off("mouseenter.slick", a.proxy(b2.interrupt, b2, !0))
            .off("mouseleave.slick", a.proxy(b2.interrupt, b2, !1)),
          b2.$slider.off("focus.slick blur.slick"),
          b2.options.arrows === !0 &&
            b2.slideCount > b2.options.slidesToShow &&
            (b2.$prevArrow && b2.$prevArrow.off("click.slick", b2.changeSlide),
            b2.$nextArrow && b2.$nextArrow.off("click.slick", b2.changeSlide)),
          b2.$list.off("touchstart.slick mousedown.slick", b2.swipeHandler),
          b2.$list.off("touchmove.slick mousemove.slick", b2.swipeHandler),
          b2.$list.off("touchend.slick mouseup.slick", b2.swipeHandler),
          b2.$list.off("touchcancel.slick mouseleave.slick", b2.swipeHandler),
          b2.$list.off("click.slick", b2.clickHandler),
          a(document).off(b2.visibilityChange, b2.visibility),
          b2.cleanUpSlideEvents(),
          b2.options.accessibility === !0 &&
            b2.$list.off("keydown.slick", b2.keyHandler),
          b2.options.focusOnSelect === !0 &&
            a(b2.$slideTrack).children().off("click.slick", b2.selectHandler),
          a(window).off(
            "orientationchange.slick.slick-" + b2.instanceUid,
            b2.orientationChange
          ),
          a(window).off("resize.slick.slick-" + b2.instanceUid, b2.resize),
          a("[draggable!=true]", b2.$slideTrack).off(
            "dragstart",
            b2.preventDefault
          ),
          a(window).off("load.slick.slick-" + b2.instanceUid, b2.setPosition),
          a(document).off(
            "ready.slick.slick-" + b2.instanceUid,
            b2.setPosition
          );
      }),
      (b.prototype.cleanUpSlideEvents = function () {
        var b2 = this;
        b2.$list.off("mouseenter.slick", a.proxy(b2.interrupt, b2, !0)),
          b2.$list.off("mouseleave.slick", a.proxy(b2.interrupt, b2, !1));
      }),
      (b.prototype.cleanUpRows = function () {
        var b2,
          a2 = this;
        a2.options.rows > 1 &&
          ((b2 = a2.$slides.children().children()),
          b2.removeAttr("style"),
          a2.$slider.empty().append(b2));
      }),
      (b.prototype.clickHandler = function (a2) {
        var b2 = this;
        b2.shouldClick === !1 &&
          (a2.stopImmediatePropagation(),
          a2.stopPropagation(),
          a2.preventDefault());
      }),
      (b.prototype.destroy = function (b2) {
        var c = this;
        c.autoPlayClear(),
          (c.touchObject = {}),
          c.cleanUpEvents(),
          a(".slick-cloned", c.$slider).detach(),
          c.$dots && c.$dots.remove(),
          c.$prevArrow &&
            c.$prevArrow.length &&
            (c.$prevArrow
              .removeClass("slick-disabled slick-arrow slick-hidden")
              .removeAttr("aria-hidden aria-disabled tabindex")
              .css("display", ""),
            c.htmlExpr.test(c.options.prevArrow) && c.$prevArrow.remove()),
          c.$nextArrow &&
            c.$nextArrow.length &&
            (c.$nextArrow
              .removeClass("slick-disabled slick-arrow slick-hidden")
              .removeAttr("aria-hidden aria-disabled tabindex")
              .css("display", ""),
            c.htmlExpr.test(c.options.nextArrow) && c.$nextArrow.remove()),
          c.$slides &&
            (c.$slides
              .removeClass(
                "slick-slide slick-active slick-center slick-visible slick-current"
              )
              .removeAttr("aria-hidden")
              .removeAttr("data-slick-index")
              .each(function () {
                a(this).attr("style", a(this).data("originalStyling"));
              }),
            c.$slideTrack.children(this.options.slide).detach(),
            c.$slideTrack.detach(),
            c.$list.detach(),
            c.$slider.append(c.$slides)),
          c.cleanUpRows(),
          c.$slider.removeClass("slick-slider"),
          c.$slider.removeClass("slick-initialized"),
          c.$slider.removeClass("slick-dotted"),
          (c.unslicked = !0),
          b2 || c.$slider.trigger("destroy", [c]);
      }),
      (b.prototype.disableTransition = function (a2) {
        var b2 = this,
          c = {};
        (c[b2.transitionType] = ""),
          b2.options.fade === !1
            ? b2.$slideTrack.css(c)
            : b2.$slides.eq(a2).css(c);
      }),
      (b.prototype.fadeSlide = function (a2, b2) {
        var c = this;
        c.cssTransitions === !1
          ? (c.$slides.eq(a2).css({ zIndex: c.options.zIndex }),
            c.$slides
              .eq(a2)
              .animate({ opacity: 1 }, c.options.speed, c.options.easing, b2))
          : (c.applyTransition(a2),
            c.$slides.eq(a2).css({ opacity: 1, zIndex: c.options.zIndex }),
            b2 &&
              setTimeout(function () {
                c.disableTransition(a2), b2.call();
              }, c.options.speed));
      }),
      (b.prototype.fadeSlideOut = function (a2) {
        var b2 = this;
        b2.cssTransitions === !1
          ? b2.$slides
              .eq(a2)
              .animate(
                { opacity: 0, zIndex: b2.options.zIndex - 2 },
                b2.options.speed,
                b2.options.easing
              )
          : (b2.applyTransition(a2),
            b2.$slides
              .eq(a2)
              .css({ opacity: 0, zIndex: b2.options.zIndex - 2 }));
      }),
      (b.prototype.filterSlides = b.prototype.slickFilter =
        function (a2) {
          var b2 = this;
          a2 !== null &&
            ((b2.$slidesCache = b2.$slides),
            b2.unload(),
            b2.$slideTrack.children(this.options.slide).detach(),
            b2.$slidesCache.filter(a2).appendTo(b2.$slideTrack),
            b2.reinit());
        }),
      (b.prototype.focusHandler = function () {
        var b2 = this;
        b2.$slider
          .off("focus.slick blur.slick")
          .on("focus.slick blur.slick", "*:not(.slick-arrow)", function (c) {
            c.stopImmediatePropagation();
            var d = a(this);
            setTimeout(function () {
              b2.options.pauseOnFocus &&
                ((b2.focussed = d.is(":focus")), b2.autoPlay());
            }, 0);
          });
      }),
      (b.prototype.getCurrent = b.prototype.slickCurrentSlide =
        function () {
          var a2 = this;
          return a2.currentSlide;
        }),
      (b.prototype.getDotCount = function () {
        var a2 = this,
          b2 = 0,
          c = 0,
          d = 0;
        if (a2.options.infinite === !0)
          for (; b2 < a2.slideCount; )
            ++d,
              (b2 = c + a2.options.slidesToScroll),
              (c +=
                a2.options.slidesToScroll <= a2.options.slidesToShow
                  ? a2.options.slidesToScroll
                  : a2.options.slidesToShow);
        else if (a2.options.centerMode === !0) d = a2.slideCount;
        else if (a2.options.asNavFor)
          for (; b2 < a2.slideCount; )
            ++d,
              (b2 = c + a2.options.slidesToScroll),
              (c +=
                a2.options.slidesToScroll <= a2.options.slidesToShow
                  ? a2.options.slidesToScroll
                  : a2.options.slidesToShow);
        else
          d =
            1 +
            Math.ceil(
              (a2.slideCount - a2.options.slidesToShow) /
                a2.options.slidesToScroll
            );
        return d - 1;
      }),
      (b.prototype.getLeft = function (a2) {
        var c,
          d,
          f,
          b2 = this,
          e = 0;
        return (
          (b2.slideOffset = 0),
          (d = b2.$slides.first().outerHeight(!0)),
          b2.options.infinite === !0
            ? (b2.slideCount > b2.options.slidesToShow &&
                ((b2.slideOffset =
                  b2.slideWidth * b2.options.slidesToShow * -1),
                (e = d * b2.options.slidesToShow * -1)),
              b2.slideCount % b2.options.slidesToScroll !== 0 &&
                a2 + b2.options.slidesToScroll > b2.slideCount &&
                b2.slideCount > b2.options.slidesToShow &&
                (a2 > b2.slideCount
                  ? ((b2.slideOffset =
                      (b2.options.slidesToShow - (a2 - b2.slideCount)) *
                      b2.slideWidth *
                      -1),
                    (e =
                      (b2.options.slidesToShow - (a2 - b2.slideCount)) *
                      d *
                      -1))
                  : ((b2.slideOffset =
                      (b2.slideCount % b2.options.slidesToScroll) *
                      b2.slideWidth *
                      -1),
                    (e =
                      (b2.slideCount % b2.options.slidesToScroll) * d * -1))))
            : a2 + b2.options.slidesToShow > b2.slideCount &&
              ((b2.slideOffset =
                (a2 + b2.options.slidesToShow - b2.slideCount) * b2.slideWidth),
              (e = (a2 + b2.options.slidesToShow - b2.slideCount) * d)),
          b2.slideCount <= b2.options.slidesToShow &&
            ((b2.slideOffset = 0), (e = 0)),
          b2.options.centerMode === !0 && b2.options.infinite === !0
            ? (b2.slideOffset +=
                b2.slideWidth * Math.floor(b2.options.slidesToShow / 2) -
                b2.slideWidth)
            : b2.options.centerMode === !0 &&
              ((b2.slideOffset = 0),
              (b2.slideOffset +=
                b2.slideWidth * Math.floor(b2.options.slidesToShow / 2))),
          (c =
            b2.options.vertical === !1
              ? a2 * b2.slideWidth * -1 + b2.slideOffset
              : a2 * d * -1 + e),
          b2.options.variableWidth === !0 &&
            ((f =
              b2.slideCount <= b2.options.slidesToShow ||
              b2.options.infinite === !1
                ? b2.$slideTrack.children(".slick-slide").eq(a2)
                : b2.$slideTrack
                    .children(".slick-slide")
                    .eq(a2 + b2.options.slidesToShow)),
            (c =
              b2.options.rtl === !0
                ? f[0]
                  ? -1 * (b2.$slideTrack.width() - f[0].offsetLeft - f.width())
                  : 0
                : f[0]
                ? -1 * f[0].offsetLeft
                : 0),
            b2.options.centerMode === !0 &&
              ((f =
                b2.slideCount <= b2.options.slidesToShow ||
                b2.options.infinite === !1
                  ? b2.$slideTrack.children(".slick-slide").eq(a2)
                  : b2.$slideTrack
                      .children(".slick-slide")
                      .eq(a2 + b2.options.slidesToShow + 1)),
              (c =
                b2.options.rtl === !0
                  ? f[0]
                    ? -1 *
                      (b2.$slideTrack.width() - f[0].offsetLeft - f.width())
                    : 0
                  : f[0]
                  ? -1 * f[0].offsetLeft
                  : 0),
              (c += (b2.$list.width() - f.outerWidth()) / 2))),
          c
        );
      }),
      (b.prototype.getOption = b.prototype.slickGetOption =
        function (a2) {
          var b2 = this;
          return b2.options[a2];
        }),
      (b.prototype.getNavigableIndexes = function () {
        var e,
          a2 = this,
          b2 = 0,
          c = 0,
          d = [];
        for (
          a2.options.infinite === !1
            ? (e = a2.slideCount)
            : ((b2 = -1 * a2.options.slidesToScroll),
              (c = -1 * a2.options.slidesToScroll),
              (e = 2 * a2.slideCount));
          e > b2;

        )
          d.push(b2),
            (b2 = c + a2.options.slidesToScroll),
            (c +=
              a2.options.slidesToScroll <= a2.options.slidesToShow
                ? a2.options.slidesToScroll
                : a2.options.slidesToShow);
        return d;
      }),
      (b.prototype.getSlick = function () {
        return this;
      }),
      (b.prototype.getSlideCount = function () {
        var c,
          d,
          e,
          b2 = this;
        return (
          (e =
            b2.options.centerMode === !0
              ? b2.slideWidth * Math.floor(b2.options.slidesToShow / 2)
              : 0),
          b2.options.swipeToSlide === !0
            ? (b2.$slideTrack.find(".slick-slide").each(function (c2, f) {
                return f.offsetLeft - e + a(f).outerWidth() / 2 >
                  -1 * b2.swipeLeft
                  ? ((d = f), !1)
                  : void 0;
              }),
              (c =
                Math.abs(a(d).attr("data-slick-index") - b2.currentSlide) || 1))
            : b2.options.slidesToScroll
        );
      }),
      (b.prototype.goTo = b.prototype.slickGoTo =
        function (a2, b2) {
          var c = this;
          c.changeSlide(
            { data: { message: "index", index: parseInt(a2) } },
            b2
          );
        }),
      (b.prototype.init = function (b2) {
        var c = this;
        a(c.$slider).hasClass("slick-initialized") ||
          (a(c.$slider).addClass("slick-initialized"),
          c.buildRows(),
          c.buildOut(),
          c.setProps(),
          c.startLoad(),
          c.loadSlider(),
          c.initializeEvents(),
          c.updateArrows(),
          c.updateDots(),
          c.checkResponsive(!0),
          c.focusHandler()),
          b2 && c.$slider.trigger("init", [c]),
          c.options.accessibility === !0 && c.initADA(),
          c.options.autoplay && ((c.paused = !1), c.autoPlay());
      }),
      (b.prototype.initADA = function () {
        var b2 = this;
        b2.$slides
          .add(b2.$slideTrack.find(".slick-cloned"))
          .attr({ "aria-hidden": "true", tabindex: "-1" })
          .find("a, input, button, select")
          .attr({ tabindex: "-1" }),
          b2.$slideTrack.attr("role", "group"),
          b2.$slides
            .not(b2.$slideTrack.find(".slick-cloned"))
            .each(function (c) {
              a(this).attr({
                role: "group",
                "aria-describedby": "slick-slide" + c + b2.instanceUid,
              });
            }),
          b2.$dots !== null &&
            b2.$dots
              .attr("role", "group")
              .find("li")
              .each(function (c) {
                (c = +c + 1),
                  a(this).attr({
                    role: "option",
                    "aria-selected": "false",
                    "aria-controls": "navigation" + c + b2.instanceUid,
                    id: "slick-slide" + c + b2.instanceUid,
                  });
              })
              .first()
              .attr("aria-selected", "true")
              .end()
              .find("button")
              .attr("role", "button")
              .end()
              .closest("div")
              .attr("role", "toolbar"),
          b2.activateADA();
      }),
      (b.prototype.initArrowEvents = function () {
        var a2 = this;
        a2.options.arrows === !0 &&
          a2.slideCount > a2.options.slidesToShow &&
          (a2.$prevArrow
            .off("click.slick")
            .on("click.slick", { message: "previous" }, a2.changeSlide),
          a2.$nextArrow
            .off("click.slick")
            .on("click.slick", { message: "next" }, a2.changeSlide));
      }),
      (b.prototype.initDotEvents = function () {
        var b2 = this;
        b2.options.dots === !0 &&
          b2.slideCount > b2.options.slidesToShow &&
          a("li", b2.$dots).on(
            "click.slick",
            { message: "index" },
            b2.changeSlide
          ),
          b2.options.dots === !0 &&
            b2.options.pauseOnDotsHover === !0 &&
            a("li", b2.$dots)
              .on("mouseenter.slick", a.proxy(b2.interrupt, b2, !0))
              .on("mouseleave.slick", a.proxy(b2.interrupt, b2, !1));
      }),
      (b.prototype.initSlideEvents = function () {
        var b2 = this;
        b2.options.pauseOnHover &&
          (b2.$list.on("mouseenter.slick", a.proxy(b2.interrupt, b2, !0)),
          b2.$list.on("mouseleave.slick", a.proxy(b2.interrupt, b2, !1)));
      }),
      (b.prototype.initializeEvents = function () {
        var b2 = this;
        b2.initArrowEvents(),
          b2.initDotEvents(),
          b2.initSlideEvents(),
          b2.$list.on(
            "touchstart.slick mousedown.slick",
            { action: "start" },
            b2.swipeHandler
          ),
          b2.$list.on(
            "touchmove.slick mousemove.slick",
            { action: "move" },
            b2.swipeHandler
          ),
          b2.$list.on(
            "touchend.slick mouseup.slick",
            { action: "end" },
            b2.swipeHandler
          ),
          b2.$list.on(
            "touchcancel.slick mouseleave.slick",
            { action: "end" },
            b2.swipeHandler
          ),
          b2.$list.on("click.slick", b2.clickHandler),
          a(document).on(b2.visibilityChange, a.proxy(b2.visibility, b2)),
          b2.options.accessibility === !0 &&
            b2.$list.on("keydown.slick", b2.keyHandler),
          b2.options.focusOnSelect === !0 &&
            a(b2.$slideTrack).children().on("click.slick", b2.selectHandler),
          a(window).on(
            "orientationchange.slick.slick-" + b2.instanceUid,
            a.proxy(b2.orientationChange, b2)
          ),
          a(window).on(
            "resize.slick.slick-" + b2.instanceUid,
            a.proxy(b2.resize, b2)
          ),
          a("[draggable!=true]", b2.$slideTrack).on(
            "dragstart",
            b2.preventDefault
          ),
          a(window).on("load.slick.slick-" + b2.instanceUid, b2.setPosition),
          a(document).on("ready.slick.slick-" + b2.instanceUid, b2.setPosition);
      }),
      (b.prototype.initUI = function () {
        var a2 = this;
        a2.options.arrows === !0 &&
          a2.slideCount > a2.options.slidesToShow &&
          (a2.$prevArrow.show(), a2.$nextArrow.show()),
          a2.options.dots === !0 &&
            a2.slideCount > a2.options.slidesToShow &&
            a2.$dots.show();
      }),
      (b.prototype.keyHandler = function (a2) {
        var b2 = this;
        a2.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
          (a2.keyCode === 37 && b2.options.accessibility === !0
            ? b2.changeSlide({
                data: { message: b2.options.rtl === !0 ? "next" : "previous" },
              })
            : a2.keyCode === 39 &&
              b2.options.accessibility === !0 &&
              b2.changeSlide({
                data: { message: b2.options.rtl === !0 ? "previous" : "next" },
              }));
      }),
      (b.prototype.lazyLoad = function () {
        function g(c2) {
          a("img[data-lazy]", c2).each(function () {
            var c3 = a(this),
              d2 = a(this).attr("data-lazy"),
              e2 = document.createElement("img");
            (e2.onload = function () {
              c3.animate({ opacity: 0 }, 100, function () {
                c3.attr("src", d2).animate({ opacity: 1 }, 200, function () {
                  c3.removeAttr("data-lazy").removeClass("slick-loading");
                }),
                  b2.$slider.trigger("lazyLoaded", [b2, c3, d2]);
              });
            }),
              (e2.onerror = function () {
                c3
                  .removeAttr("data-lazy")
                  .removeClass("slick-loading")
                  .addClass("slick-lazyload-error"),
                  b2.$slider.trigger("lazyLoadError", [b2, c3, d2]);
              }),
              (e2.src = d2);
          });
        }
        var c,
          d,
          e,
          f,
          b2 = this;
        b2.options.centerMode === !0
          ? b2.options.infinite === !0
            ? ((e = b2.currentSlide + (b2.options.slidesToShow / 2 + 1)),
              (f = e + b2.options.slidesToShow + 2))
            : ((e = Math.max(
                0,
                b2.currentSlide - (b2.options.slidesToShow / 2 + 1)
              )),
              (f = 2 + (b2.options.slidesToShow / 2 + 1) + b2.currentSlide))
          : ((e = b2.options.infinite
              ? b2.options.slidesToShow + b2.currentSlide
              : b2.currentSlide),
            (f = Math.ceil(e + b2.options.slidesToShow)),
            b2.options.fade === !0 &&
              (e > 0 && e--, f <= b2.slideCount && f++)),
          (c = b2.$slider.find(".slick-slide").slice(e, f)),
          g(c),
          b2.slideCount <= b2.options.slidesToShow
            ? ((d = b2.$slider.find(".slick-slide")), g(d))
            : b2.currentSlide >= b2.slideCount - b2.options.slidesToShow
            ? ((d = b2.$slider
                .find(".slick-cloned")
                .slice(0, b2.options.slidesToShow)),
              g(d))
            : b2.currentSlide === 0 &&
              ((d = b2.$slider
                .find(".slick-cloned")
                .slice(-1 * b2.options.slidesToShow)),
              g(d));
      }),
      (b.prototype.loadSlider = function () {
        var a2 = this;
        a2.setPosition(),
          a2.$slideTrack.css({ opacity: 1 }),
          a2.$slider.removeClass("slick-loading"),
          a2.initUI(),
          a2.options.lazyLoad === "progressive" && a2.progressiveLazyLoad();
      }),
      (b.prototype.next = b.prototype.slickNext =
        function () {
          var a2 = this;
          a2.changeSlide({ data: { message: "next" } });
        }),
      (b.prototype.orientationChange = function () {
        var a2 = this;
        a2.checkResponsive(), a2.setPosition();
      }),
      (b.prototype.pause = b.prototype.slickPause =
        function () {
          var a2 = this;
          a2.autoPlayClear(), (a2.paused = !0);
        }),
      (b.prototype.play = b.prototype.slickPlay =
        function () {
          var a2 = this;
          a2.autoPlay(),
            (a2.options.autoplay = !0),
            (a2.paused = !1),
            (a2.focussed = !1),
            (a2.interrupted = !1);
        }),
      (b.prototype.postSlide = function (a2) {
        var b2 = this;
        b2.unslicked ||
          (b2.$slider.trigger("afterChange", [b2, a2]),
          (b2.animating = !1),
          b2.setPosition(),
          (b2.swipeLeft = null),
          b2.options.autoplay && b2.autoPlay(),
          b2.options.accessibility === !0 && b2.initADA());
      }),
      (b.prototype.prev = b.prototype.slickPrev =
        function () {
          var a2 = this;
          a2.changeSlide({ data: { message: "previous" } });
        }),
      (b.prototype.preventDefault = function (a2) {
        a2.preventDefault();
      }),
      (b.prototype.progressiveLazyLoad = function (b2) {
        b2 = b2 || 1;
        var e,
          f,
          g,
          c = this,
          d = a("img[data-lazy]", c.$slider);
        d.length
          ? ((e = d.first()),
            (f = e.attr("data-lazy")),
            (g = document.createElement("img")),
            (g.onload = function () {
              e
                .attr("src", f)
                .removeAttr("data-lazy")
                .removeClass("slick-loading"),
                c.options.adaptiveHeight === !0 && c.setPosition(),
                c.$slider.trigger("lazyLoaded", [c, e, f]),
                c.progressiveLazyLoad();
            }),
            (g.onerror = function () {
              3 > b2
                ? setTimeout(function () {
                    c.progressiveLazyLoad(b2 + 1);
                  }, 500)
                : (e
                    .removeAttr("data-lazy")
                    .removeClass("slick-loading")
                    .addClass("slick-lazyload-error"),
                  c.$slider.trigger("lazyLoadError", [c, e, f]),
                  c.progressiveLazyLoad());
            }),
            (g.src = f))
          : c.$slider.trigger("allImagesLoaded", [c]);
      }),
      (b.prototype.refresh = function (b2) {
        var d,
          e,
          c = this;
        (e = c.slideCount - c.options.slidesToShow),
          !c.options.infinite && c.currentSlide > e && (c.currentSlide = e),
          c.slideCount <= c.options.slidesToShow && (c.currentSlide = 0),
          (d = c.currentSlide),
          c.destroy(!0),
          a.extend(c, c.initials, { currentSlide: d }),
          c.init(),
          b2 || c.changeSlide({ data: { message: "index", index: d } }, !1);
      }),
      (b.prototype.registerBreakpoints = function () {
        var c,
          d,
          e,
          b2 = this,
          f = b2.options.responsive || null;
        if (a.type(f) === "array" && f.length) {
          b2.respondTo = b2.options.respondTo || "window";
          for (c in f)
            if (
              ((e = b2.breakpoints.length - 1),
              (d = f[c].breakpoint),
              f.hasOwnProperty(c))
            ) {
              for (; e >= 0; )
                b2.breakpoints[e] &&
                  b2.breakpoints[e] === d &&
                  b2.breakpoints.splice(e, 1),
                  e--;
              b2.breakpoints.push(d),
                (b2.breakpointSettings[d] = f[c].settings);
            }
          b2.breakpoints.sort(function (a2, c2) {
            return b2.options.mobileFirst ? a2 - c2 : c2 - a2;
          });
        }
      }),
      (b.prototype.reinit = function () {
        var b2 = this;
        (b2.$slides = b2.$slideTrack
          .children(b2.options.slide)
          .addClass("slick-slide")),
          (b2.slideCount = b2.$slides.length),
          b2.currentSlide >= b2.slideCount &&
            b2.currentSlide !== 0 &&
            (b2.currentSlide = b2.currentSlide - b2.options.slidesToScroll),
          b2.slideCount <= b2.options.slidesToShow && (b2.currentSlide = 0),
          b2.registerBreakpoints(),
          b2.setProps(),
          b2.setupInfinite(),
          b2.buildArrows(),
          b2.updateArrows(),
          b2.initArrowEvents(),
          b2.buildDots(),
          b2.updateDots(),
          b2.initDotEvents(),
          b2.cleanUpSlideEvents(),
          b2.initSlideEvents(),
          b2.checkResponsive(!1, !0),
          b2.options.focusOnSelect === !0 &&
            a(b2.$slideTrack).children().on("click.slick", b2.selectHandler),
          b2.setSlideClasses(
            typeof b2.currentSlide == "number" ? b2.currentSlide : 0
          ),
          b2.setPosition(),
          b2.focusHandler(),
          (b2.paused = !b2.options.autoplay),
          b2.autoPlay(),
          b2.$slider.trigger("reInit", [b2]);
      }),
      (b.prototype.resize = function () {
        var b2 = this;
        a(window).width() !== b2.windowWidth &&
          (clearTimeout(b2.windowDelay),
          (b2.windowDelay = window.setTimeout(function () {
            (b2.windowWidth = a(window).width()),
              b2.checkResponsive(),
              b2.unslicked || b2.setPosition();
          }, 50)));
      }),
      (b.prototype.removeSlide = b.prototype.slickRemove =
        function (a2, b2, c) {
          var d = this;
          return (
            typeof a2 == "boolean"
              ? ((b2 = a2), (a2 = b2 === !0 ? 0 : d.slideCount - 1))
              : (a2 = b2 === !0 ? --a2 : a2),
            d.slideCount < 1 || 0 > a2 || a2 > d.slideCount - 1
              ? !1
              : (d.unload(),
                c === !0
                  ? d.$slideTrack.children().remove()
                  : d.$slideTrack.children(this.options.slide).eq(a2).remove(),
                (d.$slides = d.$slideTrack.children(this.options.slide)),
                d.$slideTrack.children(this.options.slide).detach(),
                d.$slideTrack.append(d.$slides),
                (d.$slidesCache = d.$slides),
                void d.reinit())
          );
        }),
      (b.prototype.setCSS = function (a2) {
        var d,
          e,
          b2 = this,
          c = {};
        b2.options.rtl === !0 && (a2 = -a2),
          (d = b2.positionProp == "left" ? Math.ceil(a2) + "px" : "0px"),
          (e = b2.positionProp == "top" ? Math.ceil(a2) + "px" : "0px"),
          (c[b2.positionProp] = a2),
          b2.transformsEnabled === !1
            ? b2.$slideTrack.css(c)
            : ((c = {}),
              b2.cssTransitions === !1
                ? ((c[b2.animType] = "translate(" + d + ", " + e + ")"),
                  b2.$slideTrack.css(c))
                : ((c[b2.animType] = "translate3d(" + d + ", " + e + ", 0px)"),
                  b2.$slideTrack.css(c)));
      }),
      (b.prototype.setDimensions = function () {
        var a2 = this;
        a2.options.vertical === !1
          ? a2.options.centerMode === !0 &&
            a2.$list.css({ padding: "0px " + a2.options.centerPadding })
          : (a2.$list.height(
              a2.$slides.first().outerHeight(!0) * a2.options.slidesToShow
            ),
            a2.options.centerMode === !0 &&
              a2.$list.css({ padding: a2.options.centerPadding + " 0px" })),
          (a2.listWidth = a2.$list.width()),
          (a2.listHeight = a2.$list.height()),
          a2.options.vertical === !1 && a2.options.variableWidth === !1
            ? ((a2.slideWidth = Math.ceil(
                a2.listWidth / a2.options.slidesToShow
              )),
              a2.$slideTrack.width(
                Math.ceil(
                  a2.slideWidth * a2.$slideTrack.children(".slick-slide").length
                )
              ))
            : a2.options.variableWidth === !0
            ? a2.$slideTrack.width(5e3 * a2.slideCount)
            : ((a2.slideWidth = Math.ceil(a2.listWidth)),
              a2.$slideTrack.height(
                Math.ceil(
                  a2.$slides.first().outerHeight(!0) *
                    a2.$slideTrack.children(".slick-slide").length
                )
              ));
        var b2 = a2.$slides.first().outerWidth(!0) - a2.$slides.first().width();
        a2.options.variableWidth === !1 &&
          a2.$slideTrack.children(".slick-slide").width(a2.slideWidth - b2);
      }),
      (b.prototype.setFade = function () {
        var c,
          b2 = this;
        b2.$slides.each(function (d, e) {
          (c = b2.slideWidth * d * -1),
            b2.options.rtl === !0
              ? a(e).css({
                  position: "relative",
                  right: c,
                  top: 0,
                  zIndex: b2.options.zIndex - 2,
                  opacity: 0,
                })
              : a(e).css({
                  position: "relative",
                  left: c,
                  top: 0,
                  zIndex: b2.options.zIndex - 2,
                  opacity: 0,
                });
        }),
          b2.$slides
            .eq(b2.currentSlide)
            .css({ zIndex: b2.options.zIndex - 1, opacity: 1 });
      }),
      (b.prototype.setHeight = function () {
        var a2 = this;
        if (
          a2.options.slidesToShow === 1 &&
          a2.options.adaptiveHeight === !0 &&
          a2.options.vertical === !1
        ) {
          var b2 = a2.$slides.eq(a2.currentSlide).outerHeight(!0);
          a2.$list.css("height", b2);
        }
      }),
      (b.prototype.setOption = b.prototype.slickSetOption =
        function () {
          var c,
            d,
            e,
            f,
            h,
            b2 = this,
            g = !1;
          if (
            (a.type(arguments[0]) === "object"
              ? ((e = arguments[0]), (g = arguments[1]), (h = "multiple"))
              : a.type(arguments[0]) === "string" &&
                ((e = arguments[0]),
                (f = arguments[1]),
                (g = arguments[2]),
                arguments[0] === "responsive" &&
                a.type(arguments[1]) === "array"
                  ? (h = "responsive")
                  : typeof arguments[1] < "u" && (h = "single")),
            h === "single")
          )
            b2.options[e] = f;
          else if (h === "multiple")
            a.each(e, function (a2, c2) {
              b2.options[a2] = c2;
            });
          else if (h === "responsive")
            for (d in f)
              if (a.type(b2.options.responsive) !== "array")
                b2.options.responsive = [f[d]];
              else {
                for (c = b2.options.responsive.length - 1; c >= 0; )
                  b2.options.responsive[c].breakpoint === f[d].breakpoint &&
                    b2.options.responsive.splice(c, 1),
                    c--;
                b2.options.responsive.push(f[d]);
              }
          g && (b2.unload(), b2.reinit());
        }),
      (b.prototype.setPosition = function () {
        var a2 = this;
        a2.setDimensions(),
          a2.setHeight(),
          a2.options.fade === !1
            ? a2.setCSS(a2.getLeft(a2.currentSlide))
            : a2.setFade(),
          a2.$slider.trigger("setPosition", [a2]);
      }),
      (b.prototype.setProps = function () {
        var a2 = this,
          b2 = document.body.style;
        (a2.positionProp = a2.options.vertical === !0 ? "top" : "left"),
          a2.positionProp === "top"
            ? a2.$slider.addClass("slick-vertical")
            : a2.$slider.removeClass("slick-vertical"),
          (b2.WebkitTransition !== void 0 ||
            b2.MozTransition !== void 0 ||
            b2.msTransition !== void 0) &&
            a2.options.useCSS === !0 &&
            (a2.cssTransitions = !0),
          a2.options.fade &&
            (typeof a2.options.zIndex == "number"
              ? a2.options.zIndex < 3 && (a2.options.zIndex = 3)
              : (a2.options.zIndex = a2.defaults.zIndex)),
          b2.OTransform !== void 0 &&
            ((a2.animType = "OTransform"),
            (a2.transformType = "-o-transform"),
            (a2.transitionType = "OTransition"),
            b2.perspectiveProperty === void 0 &&
              b2.webkitPerspective === void 0 &&
              (a2.animType = !1)),
          b2.MozTransform !== void 0 &&
            ((a2.animType = "MozTransform"),
            (a2.transformType = "-moz-transform"),
            (a2.transitionType = "MozTransition"),
            b2.perspectiveProperty === void 0 &&
              b2.MozPerspective === void 0 &&
              (a2.animType = !1)),
          b2.webkitTransform !== void 0 &&
            ((a2.animType = "webkitTransform"),
            (a2.transformType = "-webkit-transform"),
            (a2.transitionType = "webkitTransition"),
            b2.perspectiveProperty === void 0 &&
              b2.webkitPerspective === void 0 &&
              (a2.animType = !1)),
          b2.msTransform !== void 0 &&
            ((a2.animType = "msTransform"),
            (a2.transformType = "-ms-transform"),
            (a2.transitionType = "msTransition"),
            b2.msTransform === void 0 && (a2.animType = !1)),
          b2.transform !== void 0 &&
            a2.animType !== !1 &&
            ((a2.animType = "transform"),
            (a2.transformType = "transform"),
            (a2.transitionType = "transition")),
          (a2.transformsEnabled =
            a2.options.useTransform &&
            a2.animType !== null &&
            a2.animType !== !1);
      }),
      (b.prototype.setSlideClasses = function (a2) {
        var c,
          d,
          e,
          f,
          b2 = this;
        (d = b2.$slider
          .find(".slick-slide")
          .removeClass("slick-active slick-center slick-current")
          .attr("aria-hidden", "true")),
          b2.$slides.eq(a2).addClass("slick-current"),
          b2.options.centerMode === !0
            ? ((c = Math.floor(b2.options.slidesToShow / 2)),
              b2.options.infinite === !0 &&
                (a2 >= c && a2 <= b2.slideCount - 1 - c
                  ? b2.$slides
                      .slice(a2 - c, a2 + c + 1)
                      .addClass("slick-active")
                      .attr("aria-hidden", "false")
                  : ((e = b2.options.slidesToShow + a2),
                    d
                      .slice(e - c + 1, e + c + 2)
                      .addClass("slick-active")
                      .attr("aria-hidden", "false")),
                a2 === 0
                  ? d
                      .eq(d.length - 1 - b2.options.slidesToShow)
                      .addClass("slick-center")
                  : a2 === b2.slideCount - 1 &&
                    d.eq(b2.options.slidesToShow).addClass("slick-center")),
              b2.$slides.eq(a2).addClass("slick-center"))
            : a2 >= 0 && a2 <= b2.slideCount - b2.options.slidesToShow
            ? b2.$slides
                .slice(a2, a2 + b2.options.slidesToShow)
                .addClass("slick-active")
                .attr("aria-hidden", "false")
            : d.length <= b2.options.slidesToShow
            ? d.addClass("slick-active").attr("aria-hidden", "false")
            : ((f = b2.slideCount % b2.options.slidesToShow),
              (e =
                b2.options.infinite === !0 ? b2.options.slidesToShow + a2 : a2),
              b2.options.slidesToShow == b2.options.slidesToScroll &&
              b2.slideCount - a2 < b2.options.slidesToShow
                ? d
                    .slice(e - (b2.options.slidesToShow - f), e + f)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")
                : d
                    .slice(e, e + b2.options.slidesToShow)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")),
          b2.options.lazyLoad === "ondemand" && b2.lazyLoad();
      }),
      (b.prototype.setupInfinite = function () {
        var c,
          d,
          e,
          b2 = this;
        if (
          (b2.options.fade === !0 && (b2.options.centerMode = !1),
          b2.options.infinite === !0 &&
            b2.options.fade === !1 &&
            ((d = null), b2.slideCount > b2.options.slidesToShow))
        ) {
          for (
            e =
              b2.options.centerMode === !0
                ? b2.options.slidesToShow + 1
                : b2.options.slidesToShow,
              c = b2.slideCount;
            c > b2.slideCount - e;
            c -= 1
          )
            (d = c - 1),
              a(b2.$slides[d])
                .clone(!0)
                .attr("id", "")
                .attr("data-slick-index", d - b2.slideCount)
                .prependTo(b2.$slideTrack)
                .addClass("slick-cloned");
          for (c = 0; e > c; c += 1)
            (d = c),
              a(b2.$slides[d])
                .clone(!0)
                .attr("id", "")
                .attr("data-slick-index", d + b2.slideCount)
                .appendTo(b2.$slideTrack)
                .addClass("slick-cloned");
          b2.$slideTrack
            .find(".slick-cloned")
            .find("[id]")
            .each(function () {
              a(this).attr("id", "");
            });
        }
      }),
      (b.prototype.interrupt = function (a2) {
        var b2 = this;
        a2 || b2.autoPlay(), (b2.interrupted = a2);
      }),
      (b.prototype.selectHandler = function (b2) {
        var c = this,
          d = a(b2.target).is(".slick-slide")
            ? a(b2.target)
            : a(b2.target).parents(".slick-slide"),
          e = parseInt(d.attr("data-slick-index"));
        return (
          e || (e = 0),
          c.slideCount <= c.options.slidesToShow
            ? (c.setSlideClasses(e), void c.asNavFor(e))
            : void c.slideHandler(e)
        );
      }),
      (b.prototype.slideHandler = function (a2, b2, c) {
        var d,
          e,
          f,
          g,
          j,
          h = null,
          i = this;
        return (
          (b2 = b2 || !1),
          (i.animating === !0 && i.options.waitForAnimate === !0) ||
          (i.options.fade === !0 && i.currentSlide === a2) ||
          i.slideCount <= i.options.slidesToShow
            ? void 0
            : (b2 === !1 && i.asNavFor(a2),
              (d = a2),
              (h = i.getLeft(d)),
              (g = i.getLeft(i.currentSlide)),
              (i.currentLeft = i.swipeLeft === null ? g : i.swipeLeft),
              i.options.infinite === !1 &&
              i.options.centerMode === !1 &&
              (0 > a2 || a2 > i.getDotCount() * i.options.slidesToScroll)
                ? void (
                    i.options.fade === !1 &&
                    ((d = i.currentSlide),
                    c !== !0
                      ? i.animateSlide(g, function () {
                          i.postSlide(d);
                        })
                      : i.postSlide(d))
                  )
                : i.options.infinite === !1 &&
                  i.options.centerMode === !0 &&
                  (0 > a2 || a2 > i.slideCount - i.options.slidesToScroll)
                ? void (
                    i.options.fade === !1 &&
                    ((d = i.currentSlide),
                    c !== !0
                      ? i.animateSlide(g, function () {
                          i.postSlide(d);
                        })
                      : i.postSlide(d))
                  )
                : (i.options.autoplay && clearInterval(i.autoPlayTimer),
                  (e =
                    0 > d
                      ? i.slideCount % i.options.slidesToScroll !== 0
                        ? i.slideCount -
                          (i.slideCount % i.options.slidesToScroll)
                        : i.slideCount + d
                      : d >= i.slideCount
                      ? i.slideCount % i.options.slidesToScroll !== 0
                        ? 0
                        : d - i.slideCount
                      : d),
                  (i.animating = !0),
                  i.$slider.trigger("beforeChange", [i, i.currentSlide, e]),
                  (f = i.currentSlide),
                  (i.currentSlide = e),
                  i.setSlideClasses(i.currentSlide),
                  i.options.asNavFor &&
                    ((j = i.getNavTarget()),
                    (j = j.slick("getSlick")),
                    j.slideCount <= j.options.slidesToShow &&
                      j.setSlideClasses(i.currentSlide)),
                  i.updateDots(),
                  i.updateArrows(),
                  i.options.fade === !0
                    ? (c !== !0
                        ? (i.fadeSlideOut(f),
                          i.fadeSlide(e, function () {
                            i.postSlide(e);
                          }))
                        : i.postSlide(e),
                      void i.animateHeight())
                    : void (c !== !0
                        ? i.animateSlide(h, function () {
                            i.postSlide(e);
                          })
                        : i.postSlide(e))))
        );
      }),
      (b.prototype.startLoad = function () {
        var a2 = this;
        a2.options.arrows === !0 &&
          a2.slideCount > a2.options.slidesToShow &&
          (a2.$prevArrow.hide(), a2.$nextArrow.hide()),
          a2.options.dots === !0 &&
            a2.slideCount > a2.options.slidesToShow &&
            a2.$dots.hide(),
          a2.$slider.addClass("slick-loading");
      }),
      (b.prototype.swipeDirection = function () {
        var a2,
          b2,
          c,
          d,
          e = this;
        return (
          (a2 = e.touchObject.startX - e.touchObject.curX),
          (b2 = e.touchObject.startY - e.touchObject.curY),
          (c = Math.atan2(b2, a2)),
          (d = Math.round((180 * c) / Math.PI)),
          0 > d && (d = 360 - Math.abs(d)),
          (45 >= d && d >= 0) || (360 >= d && d >= 315)
            ? e.options.rtl === !1
              ? "left"
              : "right"
            : d >= 135 && 225 >= d
            ? e.options.rtl === !1
              ? "right"
              : "left"
            : e.options.verticalSwiping === !0
            ? d >= 35 && 135 >= d
              ? "down"
              : "up"
            : "vertical"
        );
      }),
      (b.prototype.swipeEnd = function (a2) {
        var c,
          d,
          b2 = this;
        if (
          ((b2.dragging = !1),
          (b2.interrupted = !1),
          (b2.shouldClick = !(b2.touchObject.swipeLength > 10)),
          b2.touchObject.curX === void 0)
        )
          return !1;
        if (
          (b2.touchObject.edgeHit === !0 &&
            b2.$slider.trigger("edge", [b2, b2.swipeDirection()]),
          b2.touchObject.swipeLength >= b2.touchObject.minSwipe)
        ) {
          switch ((d = b2.swipeDirection())) {
            case "left":
            case "down":
              (c = b2.options.swipeToSlide
                ? b2.checkNavigable(b2.currentSlide + b2.getSlideCount())
                : b2.currentSlide + b2.getSlideCount()),
                (b2.currentDirection = 0);
              break;
            case "right":
            case "up":
              (c = b2.options.swipeToSlide
                ? b2.checkNavigable(b2.currentSlide - b2.getSlideCount())
                : b2.currentSlide - b2.getSlideCount()),
                (b2.currentDirection = 1);
          }
          d != "vertical" &&
            (b2.slideHandler(c),
            (b2.touchObject = {}),
            b2.$slider.trigger("swipe", [b2, d]));
        } else
          b2.touchObject.startX !== b2.touchObject.curX &&
            (b2.slideHandler(b2.currentSlide), (b2.touchObject = {}));
      }),
      (b.prototype.swipeHandler = function (a2) {
        var b2 = this;
        if (
          !(
            b2.options.swipe === !1 ||
            ("ontouchend" in document && b2.options.swipe === !1) ||
            (b2.options.draggable === !1 && a2.type.indexOf("mouse") !== -1)
          )
        )
          switch (
            ((b2.touchObject.fingerCount =
              a2.originalEvent && a2.originalEvent.touches !== void 0
                ? a2.originalEvent.touches.length
                : 1),
            (b2.touchObject.minSwipe =
              b2.listWidth / b2.options.touchThreshold),
            b2.options.verticalSwiping === !0 &&
              (b2.touchObject.minSwipe =
                b2.listHeight / b2.options.touchThreshold),
            a2.data.action)
          ) {
            case "start":
              b2.swipeStart(a2);
              break;
            case "move":
              b2.swipeMove(a2);
              break;
            case "end":
              b2.swipeEnd(a2);
          }
      }),
      (b.prototype.swipeMove = function (a2) {
        var d,
          e,
          f,
          g,
          h,
          b2 = this;
        return (
          (h = a2.originalEvent !== void 0 ? a2.originalEvent.touches : null),
          !b2.dragging || (h && h.length !== 1)
            ? !1
            : ((d = b2.getLeft(b2.currentSlide)),
              (b2.touchObject.curX = h !== void 0 ? h[0].pageX : a2.clientX),
              (b2.touchObject.curY = h !== void 0 ? h[0].pageY : a2.clientY),
              (b2.touchObject.swipeLength = Math.round(
                Math.sqrt(
                  Math.pow(b2.touchObject.curX - b2.touchObject.startX, 2)
                )
              )),
              b2.options.verticalSwiping === !0 &&
                (b2.touchObject.swipeLength = Math.round(
                  Math.sqrt(
                    Math.pow(b2.touchObject.curY - b2.touchObject.startY, 2)
                  )
                )),
              (e = b2.swipeDirection()),
              e !== "vertical"
                ? (a2.originalEvent !== void 0 &&
                    b2.touchObject.swipeLength > 4 &&
                    a2.preventDefault(),
                  (g =
                    (b2.options.rtl === !1 ? 1 : -1) *
                    (b2.touchObject.curX > b2.touchObject.startX ? 1 : -1)),
                  b2.options.verticalSwiping === !0 &&
                    (g = b2.touchObject.curY > b2.touchObject.startY ? 1 : -1),
                  (f = b2.touchObject.swipeLength),
                  (b2.touchObject.edgeHit = !1),
                  b2.options.infinite === !1 &&
                    ((b2.currentSlide === 0 && e === "right") ||
                      (b2.currentSlide >= b2.getDotCount() && e === "left")) &&
                    ((f = b2.touchObject.swipeLength * b2.options.edgeFriction),
                    (b2.touchObject.edgeHit = !0)),
                  b2.options.vertical === !1
                    ? (b2.swipeLeft = d + f * g)
                    : (b2.swipeLeft =
                        d + f * (b2.$list.height() / b2.listWidth) * g),
                  b2.options.verticalSwiping === !0 &&
                    (b2.swipeLeft = d + f * g),
                  b2.options.fade === !0 || b2.options.touchMove === !1
                    ? !1
                    : b2.animating === !0
                    ? ((b2.swipeLeft = null), !1)
                    : void b2.setCSS(b2.swipeLeft))
                : void 0)
        );
      }),
      (b.prototype.swipeStart = function (a2) {
        var c,
          b2 = this;
        return (
          (b2.interrupted = !0),
          b2.touchObject.fingerCount !== 1 ||
          b2.slideCount <= b2.options.slidesToShow
            ? ((b2.touchObject = {}), !1)
            : (a2.originalEvent !== void 0 &&
                a2.originalEvent.touches !== void 0 &&
                (c = a2.originalEvent.touches[0]),
              (b2.touchObject.startX = b2.touchObject.curX =
                c !== void 0 ? c.pageX : a2.clientX),
              (b2.touchObject.startY = b2.touchObject.curY =
                c !== void 0 ? c.pageY : a2.clientY),
              void (b2.dragging = !0))
        );
      }),
      (b.prototype.unfilterSlides = b.prototype.slickUnfilter =
        function () {
          var a2 = this;
          a2.$slidesCache !== null &&
            (a2.unload(),
            a2.$slideTrack.children(this.options.slide).detach(),
            a2.$slidesCache.appendTo(a2.$slideTrack),
            a2.reinit());
        }),
      (b.prototype.unload = function () {
        var b2 = this;
        a(".slick-cloned", b2.$slider).remove(),
          b2.$dots && b2.$dots.remove(),
          b2.$prevArrow &&
            b2.htmlExpr.test(b2.options.prevArrow) &&
            b2.$prevArrow.remove(),
          b2.$nextArrow &&
            b2.htmlExpr.test(b2.options.nextArrow) &&
            b2.$nextArrow.remove(),
          b2.$slides
            .removeClass("slick-slide slick-active slick-visible slick-current")
            .attr("aria-hidden", "true")
            .css("width", "");
      }),
      (b.prototype.unslick = function (a2) {
        var b2 = this;
        b2.$slider.trigger("unslick", [b2, a2]), b2.destroy();
      }),
      (b.prototype.updateArrows = function () {
        var b2,
          a2 = this;
        (b2 = Math.floor(a2.options.slidesToShow / 2)),
          a2.options.arrows === !0 &&
            a2.slideCount > a2.options.slidesToShow &&
            !a2.options.infinite &&
            (a2.$prevArrow
              .removeClass("slick-disabled")
              .attr("aria-disabled", "false"),
            a2.$nextArrow
              .removeClass("slick-disabled")
              .attr("aria-disabled", "false"),
            a2.currentSlide === 0
              ? (a2.$prevArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"),
                a2.$nextArrow
                  .removeClass("slick-disabled")
                  .attr("aria-disabled", "false"))
              : ((a2.currentSlide >= a2.slideCount - a2.options.slidesToShow &&
                  a2.options.centerMode === !1) ||
                  (a2.currentSlide >= a2.slideCount - 1 &&
                    a2.options.centerMode === !0)) &&
                (a2.$nextArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"),
                a2.$prevArrow
                  .removeClass("slick-disabled")
                  .attr("aria-disabled", "false")));
      }),
      (b.prototype.updateDots = function () {
        var a2 = this;
        a2.$dots !== null &&
          (a2.$dots
            .find("li")
            .removeClass("slick-active")
            .attr("aria-hidden", "true"),
          a2.$dots
            .find("li")
            .eq(Math.floor(a2.currentSlide / a2.options.slidesToScroll))
            .addClass("slick-active")
            .attr("aria-hidden", "false"));
      }),
      (b.prototype.visibility = function () {
        var a2 = this;
        a2.options.autoplay &&
          (document[a2.hidden] ? (a2.interrupted = !0) : (a2.interrupted = !1));
      }),
      (a.fn.slick = function () {
        var f,
          g,
          a2 = this,
          c = arguments[0],
          d = Array.prototype.slice.call(arguments, 1),
          e = a2.length;
        for (f = 0; e > f; f++)
          if (
            (typeof c == "object" || typeof c > "u"
              ? (a2[f].slick = new b(a2[f], c))
              : (g = a2[f].slick[c].apply(a2[f].slick, d)),
            typeof g < "u")
          )
            return g;
        return a2;
      });
  });